import axios from 'utils/axiosConfig';

// get available masks for campaign
export const getAvailableMasks = async ({
	restaurantID,
	campaignID
}) => {
	const { data } = await axios.get(`/restaurants/${restaurantID}/campaigns/${campaignID}/rewards`);

	return data;
};

export const reserveMask = async ({
	restaurantID,
	campaignID,
	campaignInviteID,
	campaignRewardID,
}) => {
	const { data } = await axios.post(
		`/restaurants/${restaurantID}/campaigns/${campaignID}/invitations/${campaignInviteID}/reward`,
		{
			campaign_reward_id: campaignRewardID,
		}
	);

	return data;
};

export const inviteGuest = async ({
	restaurantID,
	campaignID,
	firstName,
	lastName,
	inviterUserID,
	isGuest,
}) => {
	const { data } = await axios.post(
		`/restaurants/${restaurantID}/campaigns/${campaignID}/invitations`,
		{
			first_name: firstName,
			last_name: lastName,
			user_id: inviterUserID,
			is_guest: isGuest
		}
	);

	return data;
};

export const getInvitationDetails = async ({
	restaurantID,
	campaignID,
	campaignInviteID
}) => {
	const { data } = await axios.get(`/restaurants/${restaurantID}/campaigns/${campaignID}/invitations/${campaignInviteID}`);

	return data;
};

export const getUserByEmail = async ({
	email
}) => {
	const { data } = await axios.get(`/users/emails?email=${email}`);

	return data;
};

export const userLogin = async ({
	email,
	pw
}) => {
	const { data } = await axios.get('/login', {
		headers: {
			email,
			pw
		}
	});

	return data;
};

export const updateUserCampaignInvitation = async ({
	restaurantID,
	campaignID,
	campaignInviteID,
	userID
}) => {
	const { data } = await axios.put(
		`/restaurants/${restaurantID}/campaigns/${campaignID}/invitations/${campaignInviteID}`,
		{
			user_id: userID
		}
	);

	return data;
};

export const updateUserContactInfo = async ({
	userID,
	email,
}) => {
	const { data } = await axios.post(
		`/users/${userID}/contact_info`,
		{
			email,
			phone_number: '',
			phone_country_code: ''
		}
	);

	return data;
};

export const updateUserPassword = async ({
	userID,
	password,
}) => {
	const { data } = await axios.put(
		`/users/${userID}/password`,
		{
			password,
		}
	);

	return data;
};

export const getUserInvitations = async ({
	restaurantID,
	campaignID,
	userID
}) => {
	const { data } = await axios.get(`/restaurants/${restaurantID}/campaigns/${campaignID}/invitations/users/${userID}`);

	return data;
};

export const getUserCampaignReward = async ({
	restaurantID,
	campaignID,
	userID
}) => {
	const { data } = await axios.get(`/restaurants/${restaurantID}/campaigns/${campaignID}/rewards/users/${userID}`);

	return data;
};

export const getUserCampaignInvitations = async ({
	restaurantID,
	campaignID,
	userID
}) => {
	const { data } = await axios.get(`/restaurants/${restaurantID}/campaigns/${campaignID}/invitations/users/${userID}`);

	return data;
};

export const sendGuestInvite = async ({
	restaurantID,
	campaignID,
	campaignInviteID,
	email
}) => {
	const { data } = await axios.post('/users/invite', {
		restaurant_id: restaurantID,
		campaign_id: campaignID,
		campaign_invite_id: campaignInviteID,
		email
	});

	return data;
};
